import { render, staticRenderFns } from "./CMvContentTxt.vue?vue&type=template&id=45b58091&"
import script from "./CMvContentTxt.vue?vue&type=script&lang=ts&"
export * from "./CMvContentTxt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports